import { WallMarkerLabelSection } from 'components/minute/sidebar/MarkerSidebar/WallMarkerSiderbar/WallMarkerLabelSection';
import { WallMarkerStyleSection } from 'components/minute/sidebar/MarkerSidebar/WallMarkerSiderbar/WallMarkerStyleSection';
import { WallMarkerTransform } from 'components/minute/sidebar/MarkerSidebar/WallMarkerSiderbar/WallMarkerTransform';
import { MarkerControlsSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerControlsSection';
import { MarkerFloorSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerFloorSection';
import { useAccess } from 'hooks/access/useAccess';
import { IWallV2WorldMarker } from 'react-give-me-map';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: IWallV2WorldMarker;
}

export const WallMarkerSidebar = (props: Props): JSX.Element => {
    const { isExperimental } = useAccess();
    return (
        <S_WallMarkerSidebar className={props.className}>
            {/* Doesn't work for rotation/scale and it's actually useless for now */}
            {/* <MarkerCoordinatesSection
                coordinates={props.marker.elementData.coordinates}
                onCoordinatesChange={(coordinates) => {
                    ctxEdit.updateWorldMarkerData(props.marker.id, { coordinates });
                }}
            /> */}
            {isExperimental && <WallMarkerStyleSection marker={props.marker} />}
            <WallMarkerTransform marker={props.marker} />
            {isExperimental && <WallMarkerLabelSection marker={props.marker} />}
            <MarkerFloorSection marker={props.marker} />
            <MarkerControlsSection marker={props.marker} />
        </S_WallMarkerSidebar>
    );
};

const S_WallMarkerSidebar = styled.div``;
